import { render, staticRenderFns } from "./DynamicQuestion.vue?vue&type=template&id=2d508b95&scoped=true"
import script from "./DynamicQuestion.vue?vue&type=script&lang=js"
export * from "./DynamicQuestion.vue?vue&type=script&lang=js"
import style0 from "./DynamicQuestion.vue?vue&type=style&index=0&id=2d508b95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d508b95",
  null
  
)

export default component.exports